export const translations = {
  de: {
    nav: {
      about: "Über uns",
      why: "Warum Orthodox?",
      values: "Werte",
      locations: "Standorte",
      activities: "Aktivitäten",
      faq: "FAQ",
      contact: "Kontakt",
      leadership: "Leitung",
      join: "Mitmachen",
      login: "Login",
    },
    hero: {
      eyebrow: "Brotherhood of Eden · Schweiz",
      title1: "Glaube.",
      title2: "Gemeinschaft.",
      title3: "Hoffnung.",
      subtitle:
        "Wir sind junge orthodoxe Christen in der Schweiz. Gemeinsam beten, wachsen, fragen und leben wir unseren Glauben.",
      joinBtn: "Mitmachen",
      contactBtn: "Kontakt aufnehmen",
      trust: [
        "3 Standorte",
        "Kostenlos",
        "Offen für Fragen",
        "18 – 30 Jahre",
      ],
    },
    about: {
      eyebrow: "Über BOE",
      title: "Aus einer kleinen Runde wurde eine Bewegung.",
      p1: "BOE – Brotherhood of Eden – ist nicht in einem Büro entstanden, sondern an einem Küchentisch. Alexei, selbst orthodox aufgewachsen, suchte eine Gemeinschaft junger Christen, die mehr wollten als nur sonntags zur Liturgie zu kommen. Eine Gemeinschaft, die den Glauben durch den Alltag trägt – mit echten Gesprächen, echten Fragen, echten Freundschaften.",
      p2: "Aus ein paar Freunden in Bern wurde ein wöchentliches Treffen. Dann kamen Basel und Lausanne dazu. Heute sind wir eine Bruderschaft junger Menschen aus der ganzen Schweiz – mit unterschiedlichen Wurzeln, derselben Sehnsucht: nach Tiefe, nach Halt, nach Gemeinschaft.",
      p3: "In einer Zeit, in der viele junge Menschen einsam, überfordert oder verloren sind, glauben wir: Gemeinschaft ist kein Luxus. Sie ist überlebenswichtig. Glaube auch.",
      stat1Num: "2022",
      stat1Label: "gegründet in Bern",
      stat2Num: "3",
      stat2Label: "aktive Standorte",
      stat3Num: "100%",
      stat3Label: "ehrenamtlich",
    },
    why: {
      eyebrow: "Warum Orthodox?",
      title: "Eine alte Tradition – heute lebendiger denn je.",
      intro:
        "Vielleicht hörst du heute zum ersten Mal vom orthodoxen Christentum. Das ist okay. Wir sind nicht hier, um dich zu überzeugen – sondern um zu zeigen, was uns trägt.",
      items: [
        {
          title: "Was ist Orthodoxie?",
          desc: "Die orthodoxe Kirche ist eine der ältesten christlichen Traditionen – seit 2000 Jahren ununterbrochen. Sie verbindet Tiefe, Schönheit und Klarheit – und bewahrt den Glauben so, wie er von Anfang an gelebt wurde.",
        },
        {
          title: "Liturgie",
          desc: "Die Liturgie ist kein Schauspiel. Sie ist ein Raum, in dem Himmel und Erde sich berühren – mit Gesang, Ikonen, Weihrauch und Stille. Sie spricht alle Sinne an. Wer einmal dabei war, vergisst es nicht.",
        },
        {
          title: "Gebet",
          desc: "Gebet ist für uns kein Pflichtprogramm, sondern ein Gespräch. Mit Gott, mit uns selbst, miteinander. Es hilft uns, im Alltag nicht den Boden zu verlieren – und das Wichtige nicht zu vergessen.",
        },
        {
          title: "Tradition",
          desc: "Tradition heisst für uns nicht Stillstand. Sie ist das, was viele Generationen vor uns durch Höhen und Tiefen getragen hat. Wir tragen sie weiter – nicht als Last, sondern als Geschenk.",
        },
      ],
      footer:
        "Du musst nichts wissen. Du musst nichts können. Du musst nur kommen – mit Neugier und einem offenen Herzen.",
    },
    values: {
      eyebrow: "Unsere Werte",
      title: "Fünf Werte. Ein Weg.",
      items: [
        {
          name: "Glaube",
          desc: "Glaube ist für uns kein Etikett, sondern ein Anker. Er hilft uns, in einer lauten Welt zu wissen, wer wir sind – und wofür wir morgens aufstehen.",
        },
        {
          name: "Gemeinschaft",
          desc: "Wir glauben, dass niemand allein durchs Leben gehen muss. Bei BOE findest du Menschen, die zuhören – auch wenn das Leben gerade kompliziert ist.",
        },
        {
          name: "Liebe",
          desc: "Liebe ist nicht nur ein Gefühl. Sie ist eine Entscheidung – jeden Tag. Wir lernen, einander mit Respekt zu begegnen, auch wenn wir nicht immer einer Meinung sind.",
        },
        {
          name: "Hoffnung",
          desc: "Auch wenn die Welt dunkel scheint: Wir glauben an Auferstehung, an Neuanfang, an Sinn. Hoffnung ist für uns kein Wunschdenken, sondern Lebenshaltung.",
        },
        {
          name: "Aktion",
          desc: "Glaube zeigt sich im Tun. Wir wandern, dienen, lachen, beten, helfen – und versuchen, im Kleinen Verantwortung zu übernehmen.",
        },
      ],
    },
    locations: {
      eyebrow: "Unsere Standorte",
      title: "Drei Städte. Eine Familie.",
      subtitle: "Komm zu deinem nächstgelegenen Treffen – oder besuche uns alle.",
      bern: {
        name: "Bern",
        when: "Jeden Mittwoch · 19:00",
        desc: "Gebet, Bibelgespräch und ein langer Tisch voller guter Gespräche.",
      },
      basel: {
        name: "Basel",
        when: "Jeden Freitag · 19:30",
        desc: "Junge Stimmen, alte Traditionen – am Rhein, im Herzen der Stadt.",
      },
      lausanne: {
        name: "Lausanne",
        when: "Jeden Donnerstag · 19:00",
        desc: "Glaube, Sport, Brot und Wein – am See, unter Freunden.",
      },
      visitBtn: "Treffen besuchen",
    },
    activities: {
      eyebrow: "Was wir tun",
      title: "Mehr als nur reden.",
      subtitle: "Wir leben unseren Glauben draussen, drinnen, in Bewegung und in Stille.",
      items: [
        { name: "Wanderungen", desc: "Berge, Gipfel und ehrliche Gespräche unter freiem Himmel." },
        { name: "Naturtage", desc: "Schöpfung erleben – als Gebet ohne Worte." },
        { name: "Lagerfeuer", desc: "Wenn das Feuer brennt, brennen die Herzen mit." },
        { name: "Gemeinsames Gebet", desc: "Stille, Gesang, Kerzen – ein Raum, in dem wir ankommen." },
        { name: "Ausflüge & Sport", desc: "Fussball, Klettern, Volleyball, Städtetrips – wir bewegen uns gemeinsam." },
        { name: "Kirchenbesuche", desc: "Wir entdecken orthodoxe Kirchen in der ganzen Schweiz." },
      ],
    },
    faq: {
      eyebrow: "Häufige Fragen",
      title: "Bevor du fragst – wir haben Antworten.",
      items: [
        {
          q: "Muss ich orthodox sein?",
          a: "Nein. Wir sind eine orthodoxe Gemeinschaft, aber jeder ist willkommen – ganz gleich, ob du suchst, fragst oder einfach Freunde finden möchtest.",
        },
        {
          q: "Kann ich teilnehmen, wenn ich Zweifel habe?",
          a: "Ja, gerade dann. Zweifel sind kein Hindernis, sondern oft der Anfang von etwas Tiefem. Bei uns darfst du fragen, kritisch sein und ehrlich.",
        },
        {
          q: "Kostet BOE etwas?",
          a: "Nein. Die Mitgliedschaft bei BOE ist und bleibt kostenlos. Wir leben von Freiwilligkeit und gegenseitiger Unterstützung.",
        },
        {
          q: "Was passiert bei einem Treffen?",
          a: "Ein Treffen beginnt meist mit einem kurzen Gebet, dann ein Gespräch oder Bibeltext, danach Essen, lachen, einander kennenlernen. Keine Show, kein Druck – einfach Gemeinschaft.",
        },
        {
          q: "Können Frauen teilnehmen?",
          a: "Selbstverständlich. BOE ist offen für alle jungen Menschen – Frauen und Männer gleichermassen. Gemeinschaft kennt kein Geschlecht.",
        },
        {
          q: "Wie alt muss ich sein?",
          a: "BOE richtet sich an junge Erwachsene zwischen 18 und 30 Jahren.",
        },
        {
          q: "Ist BOE politisch?",
          a: "BOE ist keine politische Organisation. Wir stehen für orthodoxen Glauben, Gemeinschaft und gegenseitigen Respekt. Parteipolitische Werbung, Extremismus oder Versuche, unsere Gemeinschaft für politische Zwecke zu nutzen, haben bei uns keinen Platz.",
        },
        {
          q: "Wie kann ich Mitglied werden?",
          a: "Schreib uns über das Kontaktformular oder Instagram – und komm zum nächsten Treffen. Das war's. Es gibt keine Anmeldung, keine Aufnahmeprüfung, kein Kleingedrucktes.",
        },
      ],
    },
    contact: {
      eyebrow: "Schreib uns",
      title: "Lass uns reden.",
      subtitle: "Ob Frage, Anliegen oder einfach Lust auf einen Kaffee – wir antworten gerne.",
      name: "Dein Name",
      email: "Deine E-Mail",
      location: "Welche Stadt?",
      message: "Deine Nachricht",
      send: "Nachricht senden",
      sending: "Wird gesendet…",
      success: "Danke! Wir melden uns bei dir.",
      error: "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
      pickCity: "Wähle deine Stadt",
      privacy:
        "Deine Daten werden ausschliesslich zur Kontaktaufnahme verwendet und nicht veröffentlicht oder weitergegeben.",
    },
    leadership: {
      eyebrow: "Die Leitung",
      title: "Wer BOE trägt.",
      subtitle: "Menschen, die im Hintergrund Verantwortung übernehmen – in Bern, Basel und Lausanne.",
      labelFunction: "Funktion",
      labelLocation: "Standort",
      labelAge: "Alter",
      badges: { founder: "Gründer", leader: "Pionier", leaderF: "Pionierin", deputy: "Stellvertreter" },
      roles: { founder: "Gründer", leader: "Leiter Kreis", leaderF: "Leiterin Kreis", deputy: "Stellvertreter Kreis" },
    },
    footer: {
      tagline: "Eine Bruderschaft junger orthodoxer Christen in der Schweiz.",
      welcome:
        "Du bist willkommen – unabhängig davon, wo du auf deinem Glaubensweg stehst.",
      follow: "Folge uns",
      contact: "Kontakt",
      locations: "Standorte",
      rights: "Alle Rechte vorbehalten.",
      notPolitical: "Keine politische Organisation. Mitgliedschaft kostenlos.",
    },
  },

  fr: {
    nav: {
      about: "À propos",
      why: "Pourquoi orthodoxe ?",
      values: "Valeurs",
      locations: "Lieux",
      activities: "Activités",
      faq: "FAQ",
      contact: "Contact",
      leadership: "Direction",
      join: "Rejoindre",
      login: "Connexion",
    },
    hero: {
      eyebrow: "Brotherhood of Eden · Suisse",
      title1: "Foi.",
      title2: "Communauté.",
      title3: "Espérance.",
      subtitle:
        "Nous sommes de jeunes chrétiens orthodoxes en Suisse. Ensemble, nous prions, grandissons, questionnons et vivons notre foi.",
      joinBtn: "Rejoindre",
      contactBtn: "Nous contacter",
      trust: ["3 lieux", "Gratuit", "Ouvert aux questions", "18 – 30 ans"],
    },
    about: {
      eyebrow: "À propos de BOE",
      title: "D'un petit cercle est née une communauté.",
      p1: "BOE – Brotherhood of Eden – n'est pas né dans un bureau, mais autour d'une table de cuisine. Alexei, lui-même issu d'une famille orthodoxe, cherchait une communauté de jeunes chrétiens qui voulaient plus que la liturgie du dimanche. Une communauté qui vit sa foi au quotidien – avec de vraies conversations, de vraies questions, de vraies amitiés.",
      p2: "Quelques amis à Berne sont devenus une rencontre hebdomadaire. Puis Bâle et Lausanne ont rejoint. Aujourd'hui, nous sommes une fraternité de jeunes venant de toute la Suisse – de différentes origines, avec la même aspiration : la profondeur, l'ancrage, la communauté.",
      p3: "À une époque où beaucoup de jeunes se sentent seuls, dépassés ou perdus, nous le croyons : la communauté n'est pas un luxe. C'est vital. La foi aussi.",
      stat1Num: "2022",
      stat1Label: "fondée à Berne",
      stat2Num: "3",
      stat2Label: "lieux actifs",
      stat3Num: "100%",
      stat3Label: "bénévole",
    },
    why: {
      eyebrow: "Pourquoi orthodoxe ?",
      title: "Une tradition ancienne – plus vivante que jamais.",
      intro:
        "Tu entends peut-être parler du christianisme orthodoxe pour la première fois. C'est okay. Nous ne sommes pas là pour te convaincre – mais pour montrer ce qui nous porte.",
      items: [
        {
          title: "Qu'est-ce que l'orthodoxie ?",
          desc: "L'Église orthodoxe est l'une des plus anciennes traditions chrétiennes – 2000 ans sans interruption. Elle unit profondeur, beauté et clarté – et garde la foi telle qu'elle a été vécue dès le début.",
        },
        {
          title: "La liturgie",
          desc: "La liturgie n'est pas un spectacle. C'est un espace où le ciel et la terre se touchent – avec chants, icônes, encens et silence. Elle parle à tous les sens. Ceux qui y ont assisté s'en souviennent.",
        },
        {
          title: "La prière",
          desc: "Pour nous, la prière n'est pas une obligation, mais une conversation. Avec Dieu, avec nous-mêmes, entre nous. Elle nous aide à ne pas perdre pied dans le quotidien – et à ne pas oublier l'essentiel.",
        },
        {
          title: "La tradition",
          desc: "La tradition n'est pas pour nous synonyme d'immobilisme. C'est ce qui a porté de nombreuses générations à travers les hauts et les bas. Nous la transmettons – pas comme un fardeau, mais comme un cadeau.",
        },
      ],
      footer:
        "Tu n'as rien besoin de savoir. Tu n'as rien à prouver. Viens simplement – avec curiosité et un cœur ouvert.",
    },
    values: {
      eyebrow: "Nos valeurs",
      title: "Cinq valeurs. Un chemin.",
      items: [
        { name: "Foi", desc: "La foi n'est pas une étiquette, c'est une ancre. Elle nous aide à savoir qui nous sommes dans un monde bruyant – et pourquoi nous nous levons le matin." },
        { name: "Communauté", desc: "Personne ne devrait traverser la vie seul. À BOE, tu trouves des personnes qui écoutent – même quand la vie est compliquée." },
        { name: "Amour", desc: "L'amour n'est pas seulement un sentiment. C'est une décision – chaque jour. Nous apprenons à nous accueillir avec respect, même quand nos avis divergent." },
        { name: "Espérance", desc: "Même quand le monde paraît sombre : nous croyons à la résurrection, à un nouveau départ, au sens. L'espérance n'est pas un vœu pieux, c'est une attitude de vie." },
        { name: "Action", desc: "La foi se montre dans les actes. Nous marchons, servons, rions, prions, aidons – et essayons de prendre nos responsabilités, à notre échelle." },
      ],
    },
    locations: {
      eyebrow: "Nos lieux",
      title: "Trois villes. Une famille.",
      subtitle: "Rejoins la rencontre la plus proche – ou viens nous voir partout.",
      bern: { name: "Berne", when: "Chaque mercredi · 19h00", desc: "Prière, partage biblique et longues conversations autour d'une table." },
      basel: { name: "Bâle", when: "Chaque vendredi · 19h30", desc: "Jeunes voix, anciennes traditions – au bord du Rhin." },
      lausanne: { name: "Lausanne", when: "Chaque jeudi · 19h00", desc: "Foi, sport, pain et vin – au bord du lac, entre amis." },
      visitBtn: "Visiter une rencontre",
    },
    activities: {
      eyebrow: "Ce que nous faisons",
      title: "Plus que des paroles.",
      subtitle: "Nous vivons notre foi dehors, dedans, en mouvement et en silence.",
      items: [
        { name: "Randonnées", desc: "Montagnes, sommets et vraies conversations à ciel ouvert." },
        { name: "Journées nature", desc: "Vivre la création – comme une prière sans mots." },
        { name: "Feux de camp", desc: "Quand le feu brûle, les cœurs brûlent aussi." },
        { name: "Prière commune", desc: "Silence, chant, bougies – un espace où l'on arrive." },
        { name: "Sorties & sport", desc: "Foot, escalade, volley, sorties en ville – nous bougeons ensemble." },
        { name: "Visites d'églises", desc: "Nous découvrons les églises orthodoxes de toute la Suisse." },
      ],
    },
    faq: {
      eyebrow: "Questions fréquentes",
      title: "Avant de demander – voici nos réponses.",
      items: [
        { q: "Dois-je être orthodoxe ?", a: "Non. Nous sommes une communauté orthodoxe, mais tout le monde est bienvenu – que tu cherches, doutes ou veuilles simplement te faire des amis." },
        { q: "Puis-je participer si j'ai des doutes ?", a: "Oui, justement. Les doutes ne sont pas un obstacle, mais souvent le début de quelque chose de profond. Chez nous, tu peux questionner, être critique, être honnête." },
        { q: "Est-ce que BOE coûte quelque chose ?", a: "Non. L'adhésion à BOE est et restera gratuite. Nous fonctionnons sur la base du bénévolat et du soutien mutuel." },
        { q: "Que se passe-t-il lors d'une rencontre ?", a: "Une rencontre commence en général par une courte prière, puis un partage ou un texte biblique, ensuite repas, rires, faire connaissance. Pas de spectacle, pas de pression – juste de la communauté." },
        { q: "Les femmes peuvent-elles participer ?", a: "Bien sûr. BOE est ouvert à tous les jeunes – femmes et hommes également. La communauté ne connaît pas de genre." },
        { q: "Quel âge faut-il avoir ?", a: "BOE s'adresse aux jeunes adultes entre 18 et 30 ans." },
        { q: "BOE est-il politique ?", a: "BOE n'est pas une organisation politique. Nous représentons la foi orthodoxe, la communauté et le respect mutuel. La publicité partisane, l'extrémisme ou les tentatives d'utiliser notre communauté à des fins politiques n'ont pas leur place chez nous." },
        { q: "Comment puis-je devenir membre ?", a: "Écris-nous via le formulaire de contact ou Instagram – et viens à la prochaine rencontre. C'est tout. Pas d'inscription, pas de test d'admission, pas de petits caractères." },
      ],
    },
    contact: {
      eyebrow: "Écris-nous",
      title: "Parlons.",
      subtitle: "Une question, un message ou juste envie d'un café – nous répondons avec joie.",
      name: "Ton nom",
      email: "Ton e-mail",
      location: "Quelle ville ?",
      message: "Ton message",
      send: "Envoyer",
      sending: "Envoi…",
      success: "Merci ! Nous te répondons vite.",
      error: "Une erreur est survenue. Réessaie s'il te plaît.",
      pickCity: "Choisis ta ville",
      privacy:
        "Tes données sont utilisées uniquement pour te recontacter et ne seront ni publiées ni transmises.",
    },
    leadership: {
      eyebrow: "La direction",
      title: "Celles et ceux qui portent BOE.",
      subtitle: "Des personnes qui prennent leurs responsabilités – à Berne, Bâle et Lausanne.",
      labelFunction: "Fonction",
      labelLocation: "Lieu",
      labelAge: "Âge",
      badges: { founder: "Fondateur", leader: "Pionnier", leaderF: "Pionnière", deputy: "Adjoint" },
      roles: { founder: "Fondateur", leader: "Responsable cercle", leaderF: "Responsable cercle", deputy: "Adjoint cercle" },
    },
    footer: {
      tagline: "Une fraternité de jeunes chrétiens orthodoxes en Suisse.",
      welcome:
        "Tu es le bienvenu – peu importe où tu en es sur ton chemin de foi.",
      follow: "Suis-nous",
      contact: "Contact",
      locations: "Lieux",
      rights: "Tous droits réservés.",
      notPolitical: "Pas une organisation politique. Adhésion gratuite.",
    },
  },

  en: {
    nav: {
      about: "About",
      why: "Why Orthodox?",
      values: "Values",
      locations: "Locations",
      activities: "Activities",
      faq: "FAQ",
      contact: "Contact",
      leadership: "Leadership",
      join: "Join us",
      login: "Login",
    },
    hero: {
      eyebrow: "Brotherhood of Eden · Switzerland",
      title1: "Faith.",
      title2: "Community.",
      title3: "Hope.",
      subtitle:
        "We are young Orthodox Christians in Switzerland. Together we pray, grow, question, and live our faith.",
      joinBtn: "Join us",
      contactBtn: "Get in touch",
      trust: ["3 locations", "Free", "Open to questions", "18 – 30 years"],
    },
    about: {
      eyebrow: "About BOE",
      title: "From a small circle to a movement.",
      p1: "BOE – Brotherhood of Eden – wasn't born in an office, but around a kitchen table. Alexei, raised Orthodox himself, was looking for a community of young Christians who wanted more than Sunday liturgy. A community that carries faith through daily life – with real conversations, real questions, real friendships.",
      p2: "A few friends in Bern became a weekly meeting. Then Basel and Lausanne joined. Today we are a brotherhood of young people from across Switzerland – from different roots, with the same longing: depth, grounding, community.",
      p3: "In a time when many young people feel lonely, overwhelmed or lost, we believe: community isn't a luxury. It's vital. So is faith.",
      stat1Num: "2022",
      stat1Label: "founded in Bern",
      stat2Num: "3",
      stat2Label: "active locations",
      stat3Num: "100%",
      stat3Label: "volunteer-driven",
    },
    why: {
      eyebrow: "Why Orthodox?",
      title: "An ancient tradition – more alive than ever.",
      intro:
        "Maybe you're hearing about Orthodox Christianity for the first time. That's okay. We're not here to convince you – just to show what carries us.",
      items: [
        { title: "What is Orthodoxy?", desc: "The Orthodox Church is one of the oldest Christian traditions – 2000 years uninterrupted. It combines depth, beauty and clarity – and preserves the faith as it was lived from the very beginning." },
        { title: "Liturgy", desc: "Liturgy is not a performance. It's a space where heaven and earth meet – with chant, icons, incense and silence. It speaks to all the senses. Those who have witnessed it don't forget it." },
        { title: "Prayer", desc: "For us, prayer is not duty but conversation. With God, with ourselves, with each other. It helps us stay grounded in everyday life – and not forget what matters." },
        { title: "Tradition", desc: "Tradition isn't standing still. It's what carried many generations before us through highs and lows. We carry it forward – not as a burden, but as a gift." },
      ],
      footer:
        "You don't need to know anything. You don't need to prove anything. Just come – with curiosity and an open heart.",
    },
    values: {
      eyebrow: "Our values",
      title: "Five values. One path.",
      items: [
        { name: "Faith", desc: "Faith isn't a label for us – it's an anchor. It helps us know who we are in a noisy world – and what we get up for in the morning." },
        { name: "Community", desc: "No one should walk through life alone. At BOE you'll find people who listen – even when life gets complicated." },
        { name: "Love", desc: "Love isn't just a feeling. It's a decision – every day. We learn to meet each other with respect, even when we don't always agree." },
        { name: "Hope", desc: "Even when the world feels dark: we believe in resurrection, in new beginnings, in meaning. Hope isn't wishful thinking – it's a way of living." },
        { name: "Action", desc: "Faith shows in what we do. We hike, serve, laugh, pray, help – and try to take responsibility in the small things." },
      ],
    },
    locations: {
      eyebrow: "Our locations",
      title: "Three cities. One family.",
      subtitle: "Come to the nearest meeting – or visit us all.",
      bern: { name: "Bern", when: "Every Wednesday · 7:00 pm", desc: "Prayer, scripture, and a long table full of good talks." },
      basel: { name: "Basel", when: "Every Friday · 7:30 pm", desc: "Young voices, old traditions – by the Rhine." },
      lausanne: { name: "Lausanne", when: "Every Thursday · 7:00 pm", desc: "Faith, sport, bread and wine – by the lake, among friends." },
      visitBtn: "Visit a meeting",
    },
    activities: {
      eyebrow: "What we do",
      title: "More than just talking.",
      subtitle: "We live our faith outside, inside, in motion and in silence.",
      items: [
        { name: "Hiking", desc: "Mountains, summits and honest talks under open sky." },
        { name: "Nature days", desc: "Experiencing creation – like a prayer without words." },
        { name: "Campfires", desc: "When the fire burns, hearts burn with it." },
        { name: "Shared prayer", desc: "Silence, chant, candles – a space where we arrive." },
        { name: "Trips & sports", desc: "Football, climbing, volleyball, city trips – we move together." },
        { name: "Church visits", desc: "We explore Orthodox churches all over Switzerland." },
      ],
    },
    faq: {
      eyebrow: "Frequently asked",
      title: "Before you ask – we have answers.",
      items: [
        { q: "Do I have to be Orthodox?", a: "No. We are an Orthodox community, but everyone is welcome – whether you're searching, doubting, or just looking for friends." },
        { q: "Can I take part if I have doubts?", a: "Yes – especially then. Doubts aren't an obstacle, but often the beginning of something deeper. With us, you can question, be critical and honest." },
        { q: "Does BOE cost anything?", a: "No. Joining BOE is and stays completely free. We live on volunteering and mutual support." },
        { q: "What happens at a meeting?", a: "A meeting usually starts with a short prayer, then a discussion or a scripture text, then food, laughter, getting to know each other. No show, no pressure – just community." },
        { q: "Can women take part?", a: "Of course. BOE is open to all young people – women and men alike. Community knows no gender." },
        { q: "How old do I need to be?", a: "BOE is for young adults aged 18 to 30." },
        { q: "Is BOE political?", a: "BOE is not a political organization. We stand for Orthodox faith, community and mutual respect. Party-political advertising, extremism or attempts to use our community for political purposes have no place with us." },
        { q: "How can I become a member?", a: "Write to us via the contact form or Instagram – and come to the next meeting. That's it. No registration, no entry exam, no fine print." },
      ],
    },
    contact: {
      eyebrow: "Write to us",
      title: "Let's talk.",
      subtitle: "Question, request, or just a coffee – we love replying.",
      name: "Your name",
      email: "Your email",
      location: "Which city?",
      message: "Your message",
      send: "Send message",
      sending: "Sending…",
      success: "Thank you! We'll get back to you.",
      error: "Something went wrong. Please try again.",
      pickCity: "Pick your city",
      privacy:
        "Your data is used only to contact you back. We never publish or share it.",
    },
    leadership: {
      eyebrow: "The leadership",
      title: "The people who carry BOE.",
      subtitle: "People who take responsibility behind the scenes – in Bern, Basel and Lausanne.",
      labelFunction: "Role",
      labelLocation: "Location",
      labelAge: "Age",
      badges: { founder: "Founder", leader: "Pioneer", leaderF: "Pioneer", deputy: "Deputy" },
      roles: { founder: "Founder", leader: "Circle Leader", leaderF: "Circle Leader", deputy: "Circle Deputy" },
    },
    footer: {
      tagline: "A brotherhood of young Orthodox Christians in Switzerland.",
      welcome:
        "You are welcome – no matter where you are on your faith journey.",
      follow: "Follow us",
      contact: "Contact",
      locations: "Locations",
      rights: "All rights reserved.",
      notPolitical: "Not a political organization. Membership is free.",
    },
  },
};

export const LANGS = [
  { code: "de", label: "DE" },
  { code: "fr", label: "FR" },
  { code: "en", label: "EN" },
];
